import {memo} from "react";

export const SelectTemplateIcon = memo(({className, ...props}) => {
  return (
    <svg
      width="24"
      height="24"
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15 1.99998H11C10.4696 1.99998 9.96086 2.21068 9.58578 2.58576C9.21072 2.96083 9 3.46954 9 3.99997V15C9 15.5304 9.21072 16.039 9.58578 16.4142C9.96086 16.7892 10.4696 16.9999 11 16.9999H19.0001C19.5305 16.9999 20.0391 16.7892 20.4142 16.4142C20.7892 16.039 21 15.5304 21 15V7.99998M15 1.99998C15.317 1.9992 15.6307 2.06119 15.9235 2.18236C16.2163 2.30353 16.4823 2.48151 16.7059 2.70598L20.2939 6.29398C20.5185 6.51765 20.6964 6.78357 20.8176 7.07638C20.9388 7.36918 21.0008 7.68309 21 7.99998M15 1.99998V6.99999C15 7.2652 15.1053 7.51956 15.293 7.70709C15.4805 7.89462 15.7349 7.99998 16.0001 7.99998H21M4.99999 6.99997C4.46956 6.99997 3.96086 7.21069 3.58578 7.58577C3.21072 7.96083 3 8.46954 3 8.99997V19.9999C3 20.5303 3.21072 21.0391 3.58578 21.4141C3.96086 21.7893 4.46956 22 4.99999 22H13C13.3511 21.9999 13.6959 21.9075 14 21.732C14.304 21.5565 14.5565 21.304 14.732 21"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
});

SelectTemplateIcon.displayName = "SelectTemplateIcon";
